export var IconTypes;
(function (IconTypes) {
    IconTypes["Goal"] = "i-c-ev-goals";
    IconTypes["Corner"] = "i-c-ev-corners";
    IconTypes["Penalty"] = "i-c-ev-penalty";
    IconTypes["YellowCard"] = "rj-aggregate-soccer-card rj-aggregate-soccer-card--yellow";
    IconTypes["RedCard"] = "rj-aggregate-soccer-card rj-aggregate-soccer-card--red";
})(IconTypes || (IconTypes = {}));
;
export const ScoreboardIconsOrdered = {
    goals: IconTypes.Goal,
    yellowCards: IconTypes.YellowCard,
    corners: IconTypes.Corner,
    penalties: IconTypes.Penalty,
    redCards: IconTypes.RedCard
};
export var BadgeTypes;
(function (BadgeTypes) {
    BadgeTypes["Goal"] = "rj-incidents-item_badge--soccer";
})(BadgeTypes || (BadgeTypes = {}));
//# sourceMappingURL=constants.js.map